import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Badge from 'react-bootstrap/Badge';

const excludedCountries = [
  "IN",
];

const buttonVariations = [
  {
    label: <>🎰 Best Crypto Casino&Get 5BTC</>,
    title: <>BC.Game: Top Crypto Game with BTC Dividends!</>,
    content: <>Play 5000+ Casino & Live Games, 100+ Tokens & NFT, Daily Spin up
    to 5 BTC + 760% Bonus!
    </>,
    href: "https://api.xrpscan.com/api/v1/campaign/bcgame1",
  },
]
let variantIndex = 0;
try {
  variantIndex = Math.floor((Math.random()*10)) % buttonVariations.length;
} catch (error) {}
const buttonVariation = buttonVariations[variantIndex];

const BCGameButton = (props) => {
  const { location } = props;
  if (!location || excludedCountries.includes(location)) {
    return <></>
  }

  const popover = (
    <Popover id="popover-sponsor">
      <Popover.Title>
        {buttonVariation.title}
        <span className="small ml-1"><Badge variant="secondary">SPONSORED</Badge></span>
      </Popover.Title>
      <Popover.Content>{buttonVariation.content}</Popover.Content>
    </Popover>
  );

  return (
    <span>
        <OverlayTrigger
          key={'bottom'}
          placement={'bottom'}
          overlay={popover}
        >
          <Button
            variant="info"
            size="sm"
            href={buttonVariation.href}
            target="_blank"
            rel="noopener nofollow"
            className="dropdown-toggle"
          >{buttonVariation.label}</Button>
        </OverlayTrigger>
    </span>
  )
}

BCGameButton.propTypes = {
  location: PropTypes.string.isRequired,
}

export default BCGameButton;